import Vue from 'vue'
import router from '@router'
import store from '@state/store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import Chat from 'vue-beautiful-chat'
import VueClipboard from 'vue-clipboard2'
import IdleVue from 'idle-vue'

// Import the Auth0 configuration
import { domain, clientId } from './router/auth/auth_config.json'

import App from './app.vue'

// Import the plugin here
import { Auth0Plugin } from './router/auth'

// Globally register all `_base`-prefixed components
import '@components/_globals'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = false

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(VueClipboard)

Vue.use(Antd)

Vue.use(Chat)

Vue.use(IdleVue, {
  store,
  idleTime: 1800000, // 30 minutes
  startAtIdle: false,
})

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  },
})

Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
